import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-usluge',
  templateUrl: './usluge.component.html',
  styleUrls: ['./usluge.component.scss'],
})
export class UslugeComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
